import { createContext, useContext, useState, ReactNode } from 'react';
import { login as authLogin, register as authRegister } from '../api/authService';

interface AuthContextType {
  user: any;
  login: (username: string, password: string) => Promise<void>;
  register: (username: string, password: string, role: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>(null!);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<any>(null);

  const login = async (username: string, password: string) => {
    const user = await authLogin(username, password);
    setUser(user);
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  };

  const register = async (username: string, password: string, role: string) => {
    const user = await authRegister(username, password, role);
    setUser(user);
    localStorage.setItem('user', JSON.stringify(user));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
  };

  const value = { user, login, register, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}